import { render, staticRenderFns } from "./IntelligentCodeType.vue?vue&type=template&id=3dd66370&scoped=true&"
import script from "./IntelligentCodeType.vue?vue&type=script&lang=js&"
export * from "./IntelligentCodeType.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentCodeType.vue?vue&type=style&index=0&id=3dd66370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd66370",
  null
  
)

component.options.__file = "IntelligentCodeType.vue"
export default component.exports